import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CustomEase } from 'gsap/CustomEase'
//import { media } from "../utils/MediaQueries";

import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper'
// import Swiper and modules styles
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(CustomEase)

function homeNewsSlider() {
  const newsSlider = new Swiper('.js-news-slider-home', {
    modules: [Pagination, Autoplay, EffectFade],
    loop: true,
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
}
function homeMobileSlider() {
  const newsMobileSlider = new Swiper('.js-news-slider-mobile', {
    modules: [Pagination, Autoplay, EffectFade],
    loop: true,
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
}

function homeStatsSlider() {
  const statSlider = new Swiper('.js-stats-slider', {
    modules: [Pagination, Autoplay],
    loop: true,
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    autoplay: {
      delay: 6000,
    },
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
}

function homeBannerAnimation() {
  // Set up variables
  const navBar = $('.top-nav')
  const logo = $('.top-nav__logo')
  const menuLeft = $('.menu-left')
  const menuRight = $('.menu-right')
  const homeVideoContainer = $('.js-home-video')
  const homeVideoWrapper = $('.js-home-video-wrapper')
  const homeVideoInnerWrapper = $('.js-home-video-inner-wrapper')
  const homeIntro = $('.js-home-intro')
  const cheamCircle = $('.js-cheam-logo-circle')
  const loadingBg = $('.js-loading-overlay--bg')
  const loadingLogo = $('.js-loading-overlay--logo')
  let yValue = '-710'
  let paddingX = '80'
  if (window.matchMedia('(max-width: 767px)').matches) {
    paddingX = '0'
  } else if (window.matchMedia('(max-width: 991px)').matches) {
    yValue = '-645'
    paddingX = '40'
  } else if (window.matchMedia('(max-width: 1279px)').matches) {
    yValue = '-680'
  }

  // Don't allow user to scroll until banner animation is done
  if (window.matchMedia('(min-width: 768px)').matches) {
    if ($('body').hasClass('home')) {
      $('body').addClass('no-scroll')
    }
  }

  gsap.set(navBar, { opacity: 0 })
  gsap.set(cheamCircle, { opacity: 0 })
  gsap.set(homeIntro, { opacity: 0 })
  if (window.matchMedia('(min-width: 768px)').matches) {
    gsap.set(loadingLogo, { opacity: 0, yPercent: -40 })
    gsap.set(homeVideoContainer, {
      y: yValue,
      width: '100%',
      height: '100vh',
      pointerEvents: 'none',
    })
    gsap.set(homeVideoWrapper, {
      borderRadius: 0,
      width: '100%',
      height: '100vh',
    })
    gsap.set(homeVideoInnerWrapper, { height: '100vh' })
  } else {
  }

  // Banner Loading animation
  const loadBannerTL = gsap.timeline()
  if (window.matchMedia('(min-width: 768px)').matches) {
    loadBannerTL.delay(1)
    loadBannerTL.to(loadingLogo, {
      opacity: 1,
      yPercent: -50,
      duration: 1,
      ease: 'power2.inOut',
    })
    loadBannerTL.delay(1)
    loadBannerTL.to(loadingBg, {
      opacity: 0,
      duration: 1.8,
      ease: 'power2.inOut',
    })
    loadBannerTL.to(
      loadingLogo,
      { opacity: 0, duration: 1.2, ease: 'power2.inOut' },
      '>-=1.1'
    )
    loadBannerTL.add(function () {
      $('body').removeClass('no-scroll')
    }, '>')
    loadBannerTL.to(homeVideoContainer, {
      y: 0,
      paddingLeft: paddingX,
      paddingRight: paddingX,
      height: 'auto',
      pointerEvents: 'auto',
      duration: 2.5,
      ease: 'power2.inOut',
    })
    loadBannerTL.to(
      homeVideoWrapper,
      { height: 'auto', borderRadius: 20, duration: 1.2, ease: 'power2.inOut' },
      '>-=1.1'
    )
    loadBannerTL.to(
      homeVideoInnerWrapper,
      { height: 'auto', duration: 1.2, ease: 'power2.inOut' },
      '>-=1.1'
    )
  }
  loadBannerTL.to(
    homeIntro,
    { opacity: 1, duration: 2, ease: 'power2.inOut' },
    '>-=2.1'
  )
  loadBannerTL.to(
    navBar,
    { opacity: 1, duration: 1.2, ease: 'power2.inOut' },
    '>-=1.1'
  )
  loadBannerTL.to(
    cheamCircle,
    { opacity: 1, duration: 1.2, ease: 'power2.inOut' },
    '>-=1.1'
  )
}

function homeTeaserAnimation() {
  const videoTeaser = $('.js-homepage-scroll-top--video')
  const exploreMessage = $('.js-home-teaser-title')
  const teaserOne = $('.js-home-teaser-item-one')
  const teaserTwo = $('.js-home-teaser-item-two')

  if (window.matchMedia('(min-width: 1100px)').matches) {
    const teaserAnimation = gsap.timeline({
      ease: 'none',
      scrollTrigger: {
        trigger: '.js-scroll-section',
        pin: true,
        //pinSpacing: true,
        scrub: 0.2,
        start: '80px top',
        end: '1640px bottom',
        toggleActions: 'play pause play reset',
        //markers: true,
      },
    })

    teaserAnimation.fromTo(
      videoTeaser,
      { clipPath: 'inset(0% 0% 0% 0%)', yPercent: 0 },
      { clipPath: 'inset(15% 15% 15% 15%)', yPercent: -100 }
    )
    teaserAnimation.fromTo(
      exploreMessage,
      { opacity: 0 },
      { opacity: 1 },
      '>-0.4'
    )
    teaserAnimation.addLabel('teasers')
    teaserAnimation.fromTo(
      teaserOne,
      { clipPath: 'inset(0% 100% 0% 0%)' },
      { clipPath: 'inset(0% -5% 0% 0%)' },
      '<+0.5'
    )
    teaserAnimation.fromTo(
      teaserTwo,
      { clipPath: 'inset(0% 0% 0% 100%)' },
      { clipPath: 'inset(0% 0% 0% -5%)' },
      '<'
    )
    //teaserAnimation.set( contactFormSection, { xPercent: -100, opacity: 1}, '>'  );
    //teaserAnimation.fromTo( contactFormLine, { clipPath: "inset(0% 100% 0% 0%)" }, { clipPath: "inset(0% -5% 0% 0%)" }, "<" );
    //teaserAnimation.fromTo( contactFormWrapper, { opacity: 0, y: '50px' }, { opacity: 1, y: '0px' }, "<" );

    ScrollTrigger.sort()
  }
}
let currentIndex = 0

function changeWords(element) {
  const wordsSpans = element.querySelectorAll('span[data-name="word"]')

  // Hide all words except the current one
  wordsSpans.forEach((word, index) => {
    if (index !== currentIndex) {
      word.style.display = 'none'
    }
  })

  // Display the current word
  wordsSpans[currentIndex].style.display = 'inline'


}

function updateIndex(){
  // const wordsSpans = document.querySelectorAll('[data-name="word-1"] span[data-name="word"]')

  // Increment the index for the next word (looping back to 0 if at the end)
  currentIndex = (currentIndex + 1) % 3
}

function rotatingText() {
  const rotatingText = document.querySelector('[data-name="rotating-text"]')
  const word1 = document.querySelector('[data-name="word-1"]')
  const word3 = document.querySelector('[data-name="word-3"]')

  const rotatingTextTL = gsap.timeline({
    repeat: -1,
    repeatDelay: 0.15,
    yoyo: true,
  })

  gsap.set(rotatingText, { clipPath: 'inset(0% 50% 0% 50%)' })
  gsap.set(word1, { translateX: '50px', autoAlpha: 0 })
  gsap.set(word3, { translateX: '-50px', autoAlpha: 0 })

  rotatingTextTL
    .fromTo(
      rotatingText,
      {
        clipPath: 'inset(0% 50% 0% 50%)',
      },
      {
        duration: 1,
        clipPath: 'inset(0% 0% 0% 0%)',
        ease: 'power2.inOut',
      },
      0
    )
    .fromTo(
      word1,
      {
        x: '50px',
      },
      {
        duration: 1,
        autoAlpha: 1,
        x: '0',
        ease: 'power2.inOut',
      },
      0
    )
    .fromTo(
      word3,
      {
        x: '-50px',
      },
      {
        duration: 1,
        autoAlpha: 1,
        x: '0',
        ease: 'power2.inOut',
        onStart: () => {
          changeWords(rotatingText)
          changeWords(word3)
          updateIndex()
        },
      },
      0
    )
    // Timing to keep the animation
    .set({}, {}, '+=1.5')
}

function homeLoadinganimation(){
  const image1 = document.querySelector('[data-name="home-banner-image1"]')
  const image2 = document.querySelector('[data-name="home-banner-image2"]')
  const image3 = document.querySelector('[data-name="home-banner-image3"]')

  const tl = gsap.timeline({delay: 0.5})
  tl.fromTo(image1, {opacity: 0}, {opacity: 1, duration: 0.6}, 'start')
  tl.fromTo(image2, {opacity: 0}, {opacity: 1, duration: 0.6},"-0.25")
  tl.fromTo(image3, {opacity: 0}, {opacity: 1, duration: 0.6},"-0.25")


}

function homeAnimation() {
  homeNewsSlider()
  homeMobileSlider()
  homeStatsSlider()
  rotatingText()
  homeLoadinganimation()
  //homeBannerAnimation();
  //homeTeaserAnimation();
}


export default homeAnimation
